export const mutations = {
    setUser(state, payload) {
        localStorage.setItem("UserInfo", JSON.stringify(payload));
        state.user = payload;
    },
    setError(state, payload) {
        state.error = payload
    },
    setLoading(state, payload) {
        state.loading = payload
    },
    setAccessToken(state, payload) {
        localStorage.setItem("AccessToken", payload)
        state.access_token = payload
    },
    setAuth(state, payload) {
        state.isAuth = payload
    },
    setLang(state, payload) {
        state.lang = payload
    }
}